var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 42,
    viewBox: "0 0 21 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8053 14.5327V9.33888H18.5004V14.5327H16.2641L12.8588 17.8787V7.89061H10.6733V0H10.3684V7.89061H8.13204V17.8787L4.72675 14.5327H2.49044V9.33888H2.18549V14.5327H0V27.9667H2.18549V35.258H2.49044V27.9667H4.72675V20.0761L8.13204 23.4221V31.912H10.3684V42H10.6733V31.912H12.8588V23.4221L16.2641 20.0761V27.9667H18.5004V35.258H18.8053V27.9667H20.9908V14.5327H18.8053Z",
    fill: "#33CC66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.5a8a169e32d408f92a3d8c973494386c.svg";
export { ForwardRef as ReactComponent };